/* eslint-disable @typescript-eslint/no-explicit-any */

export const parseDateBR = (dateStr: string): number => {
  if (!dateStr) return 0;
  const parts = dateStr.split('/');
  if (parts.length !== 3) return 0;
  const [day, month, year] = parts;
  return new Date(Number(year), Number(month) - 1, Number(day)).getTime();
};

export const isValidDate = (dateString: string): boolean => {
  try {
    const [day, month, year] = dateString.split('/');
    if (!day || !month || !year) return false;

    const dayNum = Number(day);
    const monthNum = Number(month);
    const yearNum = Number(year);

    if (monthNum < 1 || monthNum > 12) return false;
    if (dayNum < 1 || dayNum > 31) return false;
    if (yearNum < 1900 || yearNum > 2100) return false;

    if (monthNum === 2) {
      const isLeapYear = (yearNum % 4 === 0 && yearNum % 100 !== 0) || yearNum % 400 === 0;
      if (dayNum > (isLeapYear ? 29 : 28)) return false;
    }

    if ([4, 6, 9, 11].includes(monthNum) && dayNum > 30) return false;

    return true;
  } catch {
    return false;
  }
};

export const orderByVencimento = (array: any[]): any[] => {
  return [...array].sort((a: any, b: any) => parseDateBR(b.vencimento) - parseDateBR(a.vencimento)).reverse();
};

export const orderByContratos = (array: any[], dateKeyA = 'data_contrato', dateKeyB = 'vencimento'): any[] => {
  return [...array]
    .sort((a, b) => {
      const dateA = a[dateKeyA] || a[dateKeyB];
      const dateB = b[dateKeyA] || b[dateKeyB];
      return parseDateBR(dateB) - parseDateBR(dateA);
    })
    .reverse();
};

export const MONTH_NAMES = [
  'janeiro',
  'fevereiro',
  'março',
  'abril',
  'maio',
  'junho',
  'julho',
  'agosto',
  'setembro',
  'outubro',
  'novembro',
  'dezembro',
] as const;
